module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_17.c5e49d2f.pdf";